import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { SixDetailFilterKey } from '@/types/SixDetail.types';
import { fetchSixDetailMetaAndFilesThunk } from '@/store/thunks/sixDetail/fetchMetaAndFilesThunk';
import { toggleActiveFilter } from '@/store/slices/sixDetail/sixDetailSlice';

export const toggleSixDetailFilterThunk = createAppAsyncThunk(
  'sixDetail/toggleFilter',
  async(filterKey: SixDetailFilterKey, { dispatch, getState }) => {
    dispatch(toggleActiveFilter(filterKey));

    const rootState = getState();
    const sixIdentifier = rootState.sixDetail.sixId;

    if (sixIdentifier !== undefined) {
      await dispatch(fetchSixDetailMetaAndFilesThunk(sixIdentifier));
    }
  }
);
